

/**
 * @name NavController
 * @param {object} Auth Our global auth service
 * @param {object} Session The service that holds session data
 * @param {object} Events The system events service
 */
function NavController(
  Auth,
  Session,
  Events
) {
  let vm = this;

  vm.$onInit = function() {
    vm.logout = logout;
    vm.navSizeChange = navSizeChange;
    vm.session = Session;
    vm.events = Events;
  };

  /**
   * Function to change the size of the side bar nav
   */
  function navSizeChange() {
    if (Events.navSize === 'large') {
      Events.navSize = 'small';
    } else {
      Events.navSize = 'large';
    }
  }

  /**
   * @name logout
   * @description Wrapper for the Auth logout function
   */
  function logout() {
    Auth.logout();
  }
}

angular
  .module('inkfinder')
  .controller('NavController', NavController);



// WEBPACK FOOTER //
// ./common/nav/nav.controller.js